@for (section of sortedActiveSections$(); track section.id) {
  @let sID = section.id;
  <div class="section" cdkDropList (cdkDropListDropped)="drop($event, sID)">   
    @for(component of sortedActiveComponents$()[section.id]; track component.id) {
      @let cID = component.id;
      @let cType = component.type;
      @let disableDrag = isEditMode$() && (cType !== 'navbar' && cType !== 'hero');
      @if(cID && cType) {
        <div class="components" [ngClass]="{ 'edit-mode' : isEditMode$()}" cdkDrag [cdkDragDisabled]="!disableDrag" cdkDragLockAxis="y">

            <ng-container [ngSwitch]="cType">
              <app-navbar  [id]="cID" [componentId]="cID" *ngSwitchCase="'navbar'"></app-navbar>
              <app-c-hero [id]="cID" [componentId]="cID" *ngSwitchCase="'hero'"></app-c-hero>
              <app-c-cards-gallery [id]="cID" [componentId]="cID" *ngSwitchCase="'cards-gallery'"></app-c-cards-gallery>
              <app-c-contact-form [id]="cID" [componentId]="cID" *ngSwitchCase="'contact-form'"></app-c-contact-form>
              <app-c-feature-banner [id]="cID" [componentId]="cID" *ngSwitchCase="'feature-banner'"></app-c-feature-banner>
              <app-c-cards-side-by-side [id]="cID" [componentId]="cID" *ngSwitchCase="'cards-side-by-side'"></app-c-cards-side-by-side>
              <app-c-google-maps [id]="cID" *ngSwitchCase="'google-maps'" ngSkipHydration></app-c-google-maps>
              <app-c-reviews [id]="cID" [componentId]="cID" *ngSwitchCase="'google-reviews'"></app-c-reviews>             
              <app-c-two-column-text-image [id]="cID" [componentId]="cID" *ngSwitchCase="'about-us'"></app-c-two-column-text-image>
              <app-c-single-column-text-image [id]="cID" [componentId]="cID" *ngSwitchCase="'service-details'"></app-c-single-column-text-image>
              <app-c-image-gallery [id]="cID" [componentId]="cID" *ngSwitchCase="'image-gallery'"></app-c-image-gallery>

              <div *ngSwitchDefault>
                <p>Unbekannte Komponente: {{ cType }}</p>
              </div>
            </ng-container>
            @if(disableDrag) {
              <div class="component-actions">
                <app-configuration [cID]="cID" [sID]="sID" [cType]="cType"></app-configuration>
                <div cdkDragHandle class="drag-handle"><mat-icon>drag_indicator</mat-icon></div>
            </div>
            }
        </div>
      }
    }
  </div>
  
} 
<app-footer></app-footer>